import Box from '@mui/material/Box';
import { DateInput, useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';

interface Props {
    source: string;
    alwaysOn?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const CreationDateFilter = ({}: Props) => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                border: '1px rgb(9,23,71,0.1) solid',
                p: 1,
                borderRadius: 1,
            }}
        >
            <Typography>
                <b>{translate('disorder.filters.period')}</b>
            </Typography>

            <DateInput
                source='creationDate__after'
                name='creationDate__after'
                label='disorder.filters.from'
                sx={{
                    width: 200,
                }}
                alwaysOn
            />

            <DateInput
                source='creationDate__before'
                name='creationDate__before'
                label='disorder.filters.to'
                sx={{
                    width: 200,
                }}
                alwaysOn
            />
        </Box>
    );
};

export default CreationDateFilter;
